var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[(_vm.flash_message)?_c('v-alert',{attrs:{"type":_vm.flash_message_type,"text":"","dismissible":""},on:{"input":_vm.onClose}},[_vm._v(" "+_vm._s(_vm.flash_message)+" ")]):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }